import { render, staticRenderFns } from "./CF7MenuPrincipal.vue?vue&type=template&id=753b135a&"
import script from "./CF7MenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./CF7MenuPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports